var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appContainer"},[_c('NavComponent',{attrs:{"active-index":"3"}}),_c('AboutComponent'),_c('ResumeComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }